import { render, staticRenderFns } from "./StrategyTaskConfig.vue?vue&type=template&id=4c8540c2&scoped=true"
import script from "./StrategyTaskConfig.vue?vue&type=script&lang=js"
export * from "./StrategyTaskConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8540c2",
  null
  
)

export default component.exports